module.exports = {
  data() {
    return {
      validationErrors: {
        errors: [],
      },
    }
  },
  methods: {
    hasErrorFor(key) {
      if(!this.validationErrors || !this.validationErrors.errors) {
        return false
      }

      return this.validationErrors.errors.hasOwnProperty(key)
    },

    getErrorFor(key) {
      return this.validationErrors.errors[key][0]
    },
  },
}